import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {default as Modal, withModal} from 'components/Modal';
import ErrorBlock from 'components/ErrorBlock';

import {
  MODALS,
  fetchGocardlessCustomer,
  fetchGocardlessCustomerPayments,
  SCHEDULE_TYPES
} from 'ducks/tenancy';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {composeActions} from 'ducks/common';
import {openModal, closeModal} from 'ducks/modals';

import {CustomerInfo, CustomerDetails, PaymentsHistory} from './components';

import './styles.css';

class GocardlessCustomerDetailModal extends React.Component<any> {
  componentDidMount() {
    const fetchGocardlessCustomerExtraAction = this.props.storeDataExtraActions(
      data => ({
        gocardlessCustomer: data
      })
    );
    const {data: {gocardlessCustomerId}} = this.props;

    this.props.fetchGocardlessCustomer(
      {gocardlessCustomerId},
      fetchGocardlessCustomerExtraAction
    );

    const fetchGocardlessCustomerPaymentsExtraAction = this.props.storeDataExtraActions(
      data => ({
        gocardlessCustomerPayments: data
      })
    );
    this.props.fetchGocardlessCustomerPayments(
      {gocardlessCustomerId},
      fetchGocardlessCustomerPaymentsExtraAction
    );
  }

  openInvoiceDetailModal = (invoiceScheduleType, invoiceId) => {
    const scheduleType = SCHEDULE_TYPES[invoiceScheduleType];
    const {locationRef, tenancyId} = this.props.data;

    this.props.composeActions([
      () => closeModal(MODALS.GOCARDLESS_CUSTOMER_DETAIL),
      () =>
        openModal(
          MODALS.INVOICE_DETAIL,
          {
            scheduleType,
            invoiceId,
            locationRef,
            tenancyId
          },
          true
        )
    ]);
  };

  openGocardlessPaymentDetailModal = (
    paymentScheduleType,
    gocardlessPaymentId
  ) => {
    const scheduleType = SCHEDULE_TYPES[paymentScheduleType];
    const {locationRef, tenancyId} = this.props.data;

    this.props.composeActions([
      () => closeModal(MODALS.GOCARDLESS_CUSTOMER_DETAIL),
      () =>
        openModal(
          MODALS.GOCARDLESS_PAYMENT_DETAIL,
          {
            gocardlessPaymentId,
            scheduleType,
            tenancyId,
            locationRef
          },
          true
        )
    ]);
  };

  openCancelGocardlessCustomerModal = (gocardlessCustomerId: number) => {
    this.props.requiresPermission(
      {permission: PERMISSIONS.SETUP_GOCARDLESS},
      () => {
        const {tenancyId} = this.props.data;
        this.props.openModal(MODALS.CANCEL_GOCARDLESS_CUSTOMER, {
          gocardlessCustomerId,
          tenancyId
        });
      }
    );
  };

  render() {
    const gocardlessCustomer = _.get(this.props, 'data.gocardlessCustomer');
    const gocardlessCustomerPayments = _.get(
      this.props,
      'data.gocardlessCustomerPayments'
    );

    return (
      <div>
        {gocardlessCustomer && (
          <Modal
            show={true}
            onClose={this.props.closeModal}
            className={classNames('GocardlessCustomerDetailModal', {
              noBodyShadow: _.isEmpty(gocardlessCustomerPayments)
            })}
            type={Modal.MEDIUM}>
            <Modal.Header heading="Gocardless customer" />
            <Modal.Body>
              {this.props.error && <ErrorBlock>{this.props.error}</ErrorBlock>}
              <CustomerInfo
                gocardlessCustomer={gocardlessCustomer}
                openCancelGocardlessCustomerModal={
                  this.openCancelGocardlessCustomerModal
                }
              />
              <CustomerDetails gocardlessCustomer={gocardlessCustomer} />
              <PaymentsHistory
                gocardlessCustomerPayments={gocardlessCustomerPayments}
                openInvoiceDetailModal={this.openInvoiceDetailModal}
                openGocardlessPaymentDetailModal={
                  this.openGocardlessPaymentDetailModal
                }
              />
            </Modal.Body>
          </Modal>
        )}
        {!gocardlessCustomer && null}
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchGocardlessCustomer,
  fetchGocardlessCustomerPayments,
  openModal,
  requiresPermission,
  composeActions
};

export default connect(null, mapDispatchToProps)(withModal(
  MODALS.GOCARDLESS_CUSTOMER_DETAIL
)(GocardlessCustomerDetailModal) as React.ComponentType<any>);
